import { Users, Building2 } from "lucide-react";
import Section from "@/components/Section";

const metrics = [
  { icon: Building2, value: "50+", label: "Organizations" },
  { icon: Users, value: "500+", label: "Leaders Trained" },
];

const TrustSignals = () => {
  return (
    <Section className="py-16" glow={false}>
      <div className="grid grid-cols-2 gap-4 md:gap-6 lg:gap-8 max-w-2xl lg:max-w-3xl mx-auto">
        {metrics.map((metric, index) => {
          const IconComponent = metric.icon;
          return (
            <div
              key={index}
              className="relative flex flex-col items-center text-center p-6 rounded-2xl border border-border/60 bg-card/80 backdrop-blur-sm"
            >
              <div className="mb-4 inline-flex items-center justify-center w-14 h-14 rounded-xl bg-gradient-brand">
                <IconComponent className="w-7 h-7 text-primary-foreground" />
              </div>
              <div className="text-3xl md:text-4xl lg:text-5xl font-bold text-gradient-brand mb-1">
                {metric.value}
              </div>
              <div className="text-sm md:text-base text-muted-foreground">
                {metric.label}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default TrustSignals;
